/* eslint-disable import/extensions */
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="@progress/kendo-ui" />
import './widgets/app';
import './styles/app.css';

$(() => {
	kendo.bind('#brs-portal', {});
});
